<template>
  <BaseListV2
    :model-class="ObjectAuthorization"
    :collection-filter="filter"
    :has-detail-view="false"
    help-message="Object Authorizations grant the permissions defined in a role to a selection of objects from the system."
  />
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'

import BaseListV2 from '@/components/common/BaseListV2.vue'
import { ObjectAuthorization } from '@/models/core/models'
import routerHandler from '@/router/routerHandler'
const store = useStore()
onMounted(() => {
  routerHandler.setQuery('', {
    organisation: store.getters['global/organisation'].id,
  })
})

const filter = computed(() => {
  return {
    organisation: store.getters['global/organisation'].id,
  }
})
</script>
